module.exports = __webpack_public_path__ + "img/logo.a12d726b.png";